module.exports = __webpack_public_path__ + "media/images/photo/Agriculture/Agriculture-01-358fc62836de06278ce950214f005e71.png";